module.exports = __webpack_public_path__ + "static/media/Cheese.c56f20b5.jpg";